import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

export default function OrderAndOayment() {
  const headers = {
    token: localStorage.getItem("userToken"),
  };
  let [order, setorder] = useState([]);
  let [orderid, setorderid] = useState(null);
  async function getOrdersAndpayment() {
    try {
      let res = await axios.get(
        "https://vehex-production.up.railway.app/order/allOrders"
      );
      if (res.data.message === "Orders retrieved successfully.") {
        setorder(res.data.orders);
      }
    } catch (error) {
      console.error(error.response ? error.response.data : error.message);
    }
  }

  async function deleteOrder(id) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let response = await axios.delete(
            `https://vehex-production.up.railway.app/order/deleteOrder/${id}`,
            { headers }
          );
          if (response.data.message === "Order deleted successfully.") {
            Swal.fire({
              title: "The Order has been deleted.",
              icon: "success",
              confirmButtonColor: "#3085d6",
            });
            getOrdersAndpayment();
          }
        } catch (error) {
          console.error("Error deleting order:", error);
          Swal.fire({
            title: "Error!",
            text: "There was an issue deleting the order.",
            icon: "error",
            confirmButtonColor: "#d33",
          });
        }
      }
    });
  }

  function setFormForUpdate(ordid) {
    setorderid(ordid);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    const selectedOrder = order.find((ord) => ord._id === ordid);
    console.log(selectedOrder);
    if (selectedOrder) {
      document
        .getElementById("orderform")
        .classList.replace("d-none", "d-block");
      document.getElementById("Status").value = selectedOrder.shippingStatus;
      document.getElementById("paymentStatus").value =
        selectedOrder.paymentStatus;
    }
  }
  async function updateOrder(orderid) {
    let shippingStatus = document.getElementById("Status").value;
    let paymentStatus = document.getElementById("paymentStatus").value;

    let body = {
      paymentStatus: paymentStatus,
      shippingStatus: shippingStatus,
    };

    try {
      const response = await axios.put(
        `https://vehex-production.up.railway.app/order/updateOreder/${orderid}`,
        body,
        { headers }
      );
      console.log(response.data);
      if (response.data.message === "Order updated successfully.") {
        Swal.fire({
          icon: "success",
          title: "Order updated successfully",
          confirmButtonText: "Ok",
        });
      }
      document
        .getElementById("orderform")
        .classList.replace("d-block", "d-none");
      getOrdersAndpayment();
    } catch (error) {
      console.error(
        "Error:",
        error.response ? error.response.data : error.message
      );
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please try again!",
        confirmButtonText: "Ok",
      });
    }
  }

  useEffect(() => {
    getOrdersAndpayment();
  }, []);

  return (
    <>
      <form
        className="ProductForm overflow-x-auto mb-5 d-none"
        id="orderform"
        onSubmit={(e) => e.preventDefault()}
      >
        <h1 className="heading">Update Order</h1>
        <div className="d-grid">
          <div>
            <label htmlFor="Status" className="mb-1 fs-5 fw-500 main-color">
              shipping Status
            </label>
            <input
              type="text"
              name="Status"
              id="Status"
              className="form-control fs-5 mb-2"
            />
          </div>
          <div>
            <label
              htmlFor="paymentStatus"
              className="mb-1 fs-5 fw-500 main-color"
            >
              payment Status
            </label>
            <input
              type="text"
              name="paymentStatus"
              id="paymentStatus"
              className="form-control fs-5 mb-2"
            />
          </div>
        </div>
        <button
              type="submit"
              onClick={()=>updateOrder(orderid)}
              className=" fs-5 mt-2 fw-500 "
            >
              Update Order
            </button>
      </form>

      <div className=" overflow-x-auto">
        {order?.length>0?<>
          <table className=" table table-striped">
          <thead>
            <tr>
              <th>shipping Status</th>
              <th>payment Method</th>
              <th>payment Status</th>
              <th>phone</th>
              <th>total Price</th>
              <th>Update</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {order?.map((ord) => (
              <tr key={ord._id}>
                <td>{ord.shippingStatus}</td>
                <td>{ord.paymentMethod}</td>
                <td>{ord.paymentStatus}</td>
                <td>{ord.phone}</td>
                <td>{ord.totalPrice}</td>
                <td>
                  <button
                    className="btn btn-success"
                    onClick={() => setFormForUpdate(ord._id)}
                  >
                    Update
                  </button>
                </td>
                <td>
                  <button
                    className="btn btn-danger"
                    onClick={() => deleteOrder(ord._id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </>:<div className="main-color fs-5 fw-500 text-center">No Order Found </div>}

      </div>
    </>
  );
}
